// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"e8a11eae","453":"8539c553","538":"a7d1cc68","680":"f2aadff0"}[chunkId] + ".chunk.js";
};